"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryOfProductPopup = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _reactRedux = require("react-redux");

var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));

var _CustomButton = require("./components/CustomButton");

var _FormControlLabelWrapper = require("./components/FormControlLabelWrapper");

var _config = require("../../config");

var _excluded = ["mainCategories", "categories", "values", "inProgress"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    formControlLabelWrapper: {
      paddingLeft: '21px',
      paddingTop: '12px',
      paddingBottom: '12px',
      borderWidth: '0px 0px 1px 0px',
      borderColor: '#e1e2e1',
      borderStyle: 'solid !important',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#fafafa'
      }
    },
    icon: {
      fontSize: '1.875rem'
    },
    titleContainer: {
      flexGrow: 1
    },
    toolbar: {
      justifyContent: 'space-between',
      padding: '0px 9px 0px 0px',
      backgroundColor: "#fff !important",
      background: "#fff !important"
    },
    appBar: {
      background: '#ffffff'
    },
    title: {
      '& span': {
        marginLeft: '54px'
      }
    },
    list: {
      maxHeight: '500px',
      overflow: 'auto'
    }
  };
});

var CategoryOfProductPopup = function CategoryOfProductPopup(_ref) {
  var mainCategories = _ref.mainCategories,
      categories = _ref.categories,
      values = _ref.values,
      inProgress = _ref.inProgress,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCategory = _useState2[0],
      setSelectedCategory = _useState2[1];

  var dispatch = (0, _reactRedux.useDispatch)();
  var menuPopover = (0, _react.useRef)(null);

  var handleGoBackward = function handleGoBackward() {
    var previousCategory = categories.find(function (category) {
      return Number(category.id) === Number(selectedCategory.parent_category_id);
    });
    setSelectedCategory(previousCategory);
  };

  (0, _react.useEffect)(function () {
    var menuRef = document.getElementById("menu-category");
    menuRef.style.overflow = "auto";
    menuPopover.current = menuRef;
  }, []);
  (0, _react.useEffect)(function () {
    menuPopover.current.scrollTo({
      top: 10000000000,
      behavior: 'smooth'
    });
  }, [selectedCategory]);

  var handleSelectCategory = function handleSelectCategory(category) {
    if (!category.isFetched) {
      dispatch({
        type: "FETCH_SUB_CATEGORIES_OF_PRODUCT",
        params: {
          parent_category_id: category.id,
          _sort: _config.SORT_CATEGORIES_BY,
          _fields: _config.CATEGORIES_OF_PRODUCT_FIELDS_TO_FETCH_IN_CREATION_OF_PRODUCT
        },
        categoryId: category.id,
        onSuccess: function onSuccess() {
          return setSelectedCategory(category);
        }
      });
    } else {
      setSelectedCategory(category);
    }
  };

  var closePopup = function closePopup() {
    menuPopover.current.firstChild.click();
  };

  var displayCategories = selectedCategory ? _lodash.default.filter(categories, function (category) {
    return Number(category.parent_category_id) === Number(selectedCategory.id);
  }) : mainCategories;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: "static",
    elevation: 1,
    color: "secondary",
    className: classes.appBar
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    className: classes.toolbar
  }, selectedCategory && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: handleGoBackward
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: classes.icon
  }, "arrow_back"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.titleContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    align: "center",
    color: "textPrimary",
    className: selectedCategory ? undefined : classes.title
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name) || 'Categories',
    defaultMessage: (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name) || 'Categories'
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: closePopup
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: classes.icon
  }, "close"))))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.list
  }, inProgress ? _lodash.default.map([1, 2, 3, 4, 5, 6], function (item) {
    return /*#__PURE__*/_react.default.createElement(_CustomButton.CustomButtonLoading, {
      key: item
    });
  }) : displayCategories.map(function (category) {
    return !category.is_final ? /*#__PURE__*/_react.default.createElement(_CustomButton.CustomButton, {
      handleGoForward: function handleGoForward() {
        return handleSelectCategory(category);
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, category.name)) : /*#__PURE__*/_react.default.createElement(_FormControlLabelWrapper.FormControlLabelWrapper, _extends({
      classes: classes,
      radioValue: category.id,
      isChecked: values && values['category'] === category.id,
      fieldName: "category",
      label: category.name,
      closePopup: closePopup,
      key: category.name
    }, props));
  })));
};

exports.CategoryOfProductPopup = CategoryOfProductPopup;